export type Language = 'en' | 'es';

export const translations = {
  en: {
    'common.language': 'Language',
    'common.english': 'English',
    'common.spanish': 'Spanish',
    'common.save': 'Save',
    'common.confirm': 'Confirm',
    'common.name': 'Name',
    'common.email': 'Email',
    'common.password': 'Password',
    'common.logout': 'Logout',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.search': 'Search',
    'common.show': 'Show',
    'common.entries': 'Entries',
    'common.actions': 'Actions',
    'common.details': 'Details',
    'common.overview': 'Overview',
    'common.projects': 'Projects',
    'common.employees': 'Employees',
    'common.clients': 'Clients',
    'common.invoices': 'Invoices',
    'common.reports': 'Reports',
    'common.settings': 'Settings',
    'common.profile': 'Profile',
    'common.dashboard': 'Dashboard',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.create': 'Create',
    'common.continue': 'Continue',
    'common.cancel': 'Cancel',
    'common.showAll': 'Show all',


    'board.title': 'Task Board',
    'board.addTask': 'Add Task',
    'board.addColumn': 'Add Column',
    'board.columnTitle': 'Column Title',
    'board.createTask': 'Create Task',
    'board.taskTitle': 'Task Title',
    'board.taskDescription': 'Task Description',
    'board.selectRole': 'Select Role',
    'board.planned': 'Planned',
    'board.inProgress': 'In Progress',
    'board.testing': 'Testing',
    'board.completed': 'Completed',
    'board.collapseView': 'Collapse View',
    'board.expandView': 'Expand View',
    
    // New translations for sprints
    'board.sprints': 'Sprints',
    'board.sprint': 'Sprint',
    'board.addSprint': 'Add Sprint',
    'board.createSprint': 'Create Sprint',
    'board.sprintTitle': 'Sprint Title',
    'board.sprintDescription': 'Create a new sprint to organize your tasks',
    'board.startDate': 'Start Date',
    'board.endDate': 'End Date',
    'board.status': 'Status',
    'board.selectStatus': 'Select Status',
    'board.selectSprint': 'Select Sprint',
    'board.allSprints': 'All Sprints',
    'board.current': 'Current',
    'board.noSprints': 'No sprints found',
    'board.pickDate': 'Pick a date',
    'board.sprintCreated': 'Sprint Created',
    'board.sprintAddedSuccessfully': 'Sprint has been added successfully',
    'board.errorCreatingSprint': 'There was an error creating the sprint',
    'board.taskCreated': 'Task Created',
    'board.taskAddedSuccessfully': 'Task has been added successfully',
    'board.errorCreatingTask': 'There was an error creating the task',
    'board.errorFetchingTasks': 'There was an error fetching tasks',
    'board.errorUpdatingTaskStatus': 'There was an error updating task status',
    'board.roles': 'Roles',

    'employees.title': 'Employees',
    'employees.addEmployee': 'Add Employee',
    'employees.createEmployee': 'Create Employee',
    'employees.employeeName': 'Employee Name',
    'employees.employeeEmail': 'Employee Email',
    'employees.employeeRole': 'Employee Role',
    'employees.selectRole': 'Select a role',
    'employees.admin': 'Admin',
    'employees.developer': 'Developer',
    'employees.designer': 'Designer',
    'employees.accountant': 'Accountant',
    'employees.role': 'Role',
    'employees.assignTo': 'Assign to',
    'employees.selectEmployee': 'Select an employee',
    'employees.searchEmployee': 'Search employee...',
    'employees.noEmployeesFound': 'No employees found',
    
    'board.role.all': 'All Tasks',
    'board.role.dev': 'Developer',
    'board.role.2d': '2D Artist',
    'board.role.3d': '3D Artist',
    'board.role.ui': 'UI Designer',
    'board.role.design': 'Designer',
    'board.role.audio': 'Audio',
    'board.role.techart': 'Tech Art',
    'board.role.qa': 'QA',
    'board.role.admin': 'Admin',

    'auth.welcome': 'Welcome to Overseer',
    'auth.languageSelect': 'Language',
    'auth.invalidCredentials': 'Invalid email or password. Please check your credentials and try again.',
    'auth.emailNotConfirmed': 'Please verify your email address before signing in.',
    'auth.userNotFound': 'No user found with these credentials.',
    'auth.setupIncompleteTitle': 'Account setup incomplete',
    'auth.setupIncompleteDescription': 'Your account is not fully set up yet. Contact an administrator if this persists.',
  },
  es: {
    'common.language': 'Idioma',
    'common.english': 'Inglés',
    'common.spanish': 'Español',
    'common.save': 'Guardar',
    'common.confirm': 'Confirmar',
    'common.name': 'Nombre',
    'common.email': 'Correo Electrónico',
    'common.password': 'Contraseña',
    'common.logout': 'Cerrar Sesión',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'common.search': 'Buscar',
    'common.show': 'Mostrar',
    'common.entries': 'Entradas',
    'common.actions': 'Acciones',
    'common.details': 'Detalles',
    'common.overview': 'Resumen',
    'common.projects': 'Proyectos',
    'common.employees': 'Empleados',
    'common.clients': 'Clientes',
    'common.invoices': 'Facturas',
    'common.reports': 'Informes',
    'common.settings': 'Ajustes',
    'common.profile': 'Perfil',
    'common.dashboard': 'Panel de Control',
    'common.loading': 'Cargando...',
    'common.error': 'Error',
    'common.create': 'Crear',
    'common.continue': 'Continuar',
    'common.cancel': 'Cancelar',
    'common.showAll': 'Mostrar todos',

    'board.title': 'Tablero de Tareas',
    'board.addTask': 'Agregar Tarea',
    'board.addColumn': 'Agregar Columna',
    'board.columnTitle': 'Título de Columna',
    'board.createTask': 'Crear Tarea',
    'board.taskTitle': 'Título de Tarea',
    'board.taskDescription': 'Descripción de Tarea',
    'board.selectRole': 'Seleccionar Rol',
    'board.planned': 'Planificado',
    'board.inProgress': 'En Progreso',
    'board.testing': 'En Pruebas',
    'board.completed': 'Completado',
    'board.collapseView': 'Colapsar Vista',
    'board.expandView': 'Expandir Vista',
    
    // New translations for sprints
    'board.sprints': 'Sprints',
    'board.sprint': 'Sprint',
    'board.addSprint': 'Agregar Sprint',
    'board.createSprint': 'Crear Sprint',
    'board.sprintTitle': 'Título del Sprint',
    'board.sprintDescription': 'Crear un nuevo sprint para organizar tus tareas',
    'board.startDate': 'Fecha de Inicio',
    'board.endDate': 'Fecha de Finalización',
    'board.status': 'Estado',
    'board.selectStatus': 'Seleccionar Estado',
    'board.selectSprint': 'Seleccionar Sprint',
    'board.allSprints': 'Todos los Sprints',
    'board.current': 'Actual',
    'board.noSprints': 'No se encontraron sprints',
    'board.pickDate': 'Elegir fecha',
    'board.sprintCreated': 'Sprint Creado',
    'board.sprintAddedSuccessfully': 'El sprint se ha agregado correctamente',
    'board.errorCreatingSprint': 'Hubo un error al crear el sprint',
    'board.taskCreated': 'Tarea Creada',
    'board.taskAddedSuccessfully': 'La tarea se ha agregado correctamente',
    'board.errorCreatingTask': 'Hubo un error al crear la tarea',
    'board.errorFetchingTasks': 'Hubo un error al obtener las tareas',
    'board.errorUpdatingTaskStatus': 'Hubo un error al actualizar el estado de la tarea',
    'board.roles': 'Roles',

    'employees.title': 'Empleados',
    'employees.addEmployee': 'Agregar Empleado',
    'employees.createEmployee': 'Crear Empleado',
    'employees.employeeName': 'Nombre del Empleado',
    'employees.employeeEmail': 'Correo Electrónico del Empleado',
    'employees.employeeRole': 'Rol del Empleado',
    'employees.selectRole': 'Seleccionar un rol',
    'employees.admin': 'Administrador',
    'employees.developer': 'Desarrollador',
    'employees.designer': 'Diseñador',
    'employees.accountant': 'Contador',
    'employees.role': 'Rol',
    'employees.assignTo': 'Asignar a',
    'employees.selectEmployee': 'Seleccionar un empleado',
    'employees.searchEmployee': 'Buscar empleado...',
    'employees.noEmployeesFound': 'No se encontraron empleados',


    'board.role.all': 'Todas las Tareas',
    'board.role.dev': 'Desarrollador',
    'board.role.2d': 'Artista 2D',
    'board.role.3d': 'Artista 3D',
    'board.role.ui': 'Diseñador UI',
    'board.role.design': 'Diseñador',
    'board.role.audio': 'Audio',
    'board.role.techart': 'Arte Técnico',
    'board.role.qa': 'Control de Calidad',
    'board.role.admin': 'Administrador',

    'auth.welcome': 'Bienvenido a Overseer',
    'auth.languageSelect': 'Idioma',
    'auth.invalidCredentials': 'Correo o contraseña incorrectos. Verifica tus credenciales e inténtalo de nuevo.',
    'auth.emailNotConfirmed': 'Verifica tu correo electrónico antes de iniciar sesión.',
    'auth.userNotFound': 'No se encontró un usuario con estas credenciales.',
    'auth.setupIncompleteTitle': 'Configuración de cuenta incompleta',
    'auth.setupIncompleteDescription': 'Tu cuenta aún no está completamente configurada. Contacta a un administrador si esto persiste.',
  },
};
